export default __webpack_public_path__ + "static/media/facebook.0f920548.png";